import { DeleteIcon, EditIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import ConfirmDeleteDialog from '../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import { ExpenseCategoryDatabase, ExpenseDatabase } from '../../../../types';
import { formatAmount } from '../../utils/formatAmount';
import { formatExpenseMonth } from '../../utils/expenseStats';
import ExpenseFormDialog from '../ExpenseFormDialog/ExpenseFormDialog';
import { useExpenseMenuAction } from './useExpenseMenuAction';

type Props = {
  expense: ExpenseDatabase;
  categories: ExpenseCategoryDatabase[];
};

export default function ExpenseMenuAction(props: Props) {
  const hook = useExpenseMenuAction({ expenseId: props.expense.id });
  const monthLabel = formatExpenseMonth(props.expense.month);

  return (
    <>
      <ResourceMenuActions
        size="small"
        tooltip={`Options de la dépense de ${monthLabel}`}
        actions={[
          { id: 'edit', label: 'Modifier', icon: <EditIcon fontSize="small" />, onClick: hook.handleOpenEdit },
          { id: 'delete', label: 'Supprimer', icon: <DeleteIcon fontSize="small" />, onClick: hook.handleOpenDelete },
        ]}
      />

      {hook.isEditOpen ? (
        <ExpenseFormDialog
          expense={props.expense}
          categories={props.categories}
          onClose={hook.handleCloseEdit}
        />
      ) : null}

      {hook.isDeleteOpen ? (
        <ConfirmDeleteDialog
          title="Supprimer la dépense"
          onConfirm={hook.handleConfirmDelete}
          onClose={hook.handleCloseDelete}
        >
          Supprimer la dépense de {formatAmount(props.expense.amount)} enregistrée pour {monthLabel} ?
        </ConfirmDeleteDialog>
      ) : null}
    </>
  );
}
